// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"DetailsRow_rowContainer__mv3eP","key":"DetailsRow_key__1EDz7","value":"DetailsRow_value__2SVvd"};